import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { GameWithoutLivestream } from '../../types'
import { VideoMeta } from '../VideoMeta/VideoMeta'

type VideoPageMetaProps = {
  mediaObject: GameWithoutLivestream
}
export const VideoPageMeta: FC<VideoPageMetaProps> = ({ mediaObject }) => {
  const channel = useSelector(channelSelector)

  if (!mediaObject || !channel?.data) {
    return <></>
  }
  return (
    <>
      <VideoMeta channel={channel.data} mediaObject={mediaObject} />
    </>
  )
}
